import { useState } from "react";
import "../../assests/Login.css";
import { App, Button, Spin } from "antd";
import {
  EyeInvisibleOutlined,
  EyeTwoTone,
  CopyrightOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import Logo from "../../assests/Shalina Healthcare Logo.pdf.png";
import Logo1 from "../../assests/Untitled design (10).png";
import msicon from "../../assests/ms.png";
import { AxiosFirst, MSCLIENT_ID, MSLOGINURL } from "../../config/config";
import VerifyEmailMessage from "./VerifyEmailMessage";
import TemResetPassword from "./TemResetPassword";
import ForgetPassword from "./ForgetPassword";
import { msalInstance } from "../../config/MsalConfig";
import { Link } from "react-router-dom";

const loginRequest = { scopes: ["openid", "profile", "email"] };

const Login = () => {
  const { notification } = App.useApp();

  const [loader, setLoader] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [user_id, set_user_id] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const [verify_email, set_verify_email] = useState(false);
  const [temporary_password, set_temporary_password] = useState(false);

  // NEW STATE

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const LOGIN_ACCOUNT = async () => {
    setLoader(true);
    try {
      const formData = new FormData();
      formData.append("email", email);
      formData.append("password", password);
      const res = await AxiosFirst.post("login-view/", formData);
      if (res?.data?.status) {
        if (res?.data?.email_verified) {
          set_verify_email(true);
        } else if (res?.data?.temporary_password) {
          set_user_id(res?.data?.user_id);
          set_temporary_password(true);
        } else {
          window.location.href = "/";
        }
      } else {
        setError(res.data.error || "Login failed");
      }
    } catch (err) {
      setError("Network error");
    }
    setLoader(false);
  };

  const handleMicrosoftLogin = async () => {
    try {

      // 1️⃣ Microsoft popup login
      const loginResponse = await msalInstance.loginPopup(loginRequest);

      // console.log("Microsoft Response:", loginResponse);

      const idToken = loginResponse.idToken;
      // const account = loginResponse.account;

      // 2️⃣ Get access token silently
      // const tokenResponse = await msalInstance.acquireTokenSilent({
      //     account: account,
      //     scopes: loginRequest.scopes
      // });
      // console.log(idToken);
      // const accessToken = tokenResponse.accessToken;

      // 3️⃣ Send tokens to backend
      const res = await fetch(MSLOGINURL, {
        method: "POST",
        credentials: "include",
        headers: {
          "Authorization": "Bearer " + idToken,
          "ms-client-id": MSCLIENT_ID,
          "Content-Type": "application/json",
        },
        // body: JSON.stringify({
        //     access_token: accessToken,
        //     account: account
        // })
      });

      const data = await res.json();
      console.log(data);
      if (!data.status) {
        notification.error({
          message: "Failded",
          description: "You are not registered on the LMS. Please contact the administrator.",
        });
        return;
      }

      // Cookies already set by backend, reload
      window.location.reload();

    } catch (err) {
      notification.error({
        message: "Failded",
        description: "Microsoft login failed",
      });
      setLoader(false);
    }
  };

  return (
    <>
      {verify_email ? (
        <VerifyEmailMessage />
      ) : temporary_password ? (
        <TemResetPassword
          user_id={user_id}
          set_temporary_password={set_temporary_password}
        />
      ) : (
        <div className="login-container">
          {/* LEFT PANEL */}
          <div className="login-left">
            <div className="left-content">
              <img src={Logo1} alt="logo" className="logo" />

              <h1>
                Enterprise Security <br />
                <span>Training Platform</span>
              </h1>

              <p>
                Empower your workforce with cybersecurity training. Track
                progress, ensure compliance, and build a security-aware culture.
              </p>

              <div className="feature-grid">
                <div className="feature-box">
                  Compliance Ready <br />
                  <span>Meet regulatory requirements</span>
                </div>
                <div className="feature-box">
                  Rich Content <br />
                  <span>Video, PDF & interactive</span>
                </div>
                <div className="feature-box">
                  Certifications <br />
                  <span>Verifiable credentials</span>
                </div>
                <div className="feature-box">
                  Team Management <br />
                  <span>Department-level control</span>
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT PANEL */}
          <div className="login-right">
            <div className="login-card">
              <img src={Logo} alt="logo" className="logo" style={{ marginLeft: "120px" }} />

              {/* 

              <h2>Welcome</h2>
              <p className="subtitle">
                Sign in to continue to your training portal
              </p> */}

              {/* {error && <p className="error">{error}</p>} */}
              
              {/* <input
                className="input"
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />

              <div className="password-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  className="input"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <span onClick={togglePasswordVisibility}>
                  {showPassword ? (
                    <EyeTwoTone style={{ marginTop: "-5px" }} />
                  ) : (
                    <EyeInvisibleOutlined style={{ color: "black", marginTop: "-5px" }} />
                  )}
                </span>
              </div>  */}

              {/* <Link
                className="forgot"
                style={{ cursor: "pointer" }}
                to="/forget-password"
              >
                Forgot password?
              </Link> */}

               {/* {loader ? (
                <Button className="btn-primary">
                  <Spin style={{color:"white"}} indicator={<LoadingOutlined spin />} />
                </Button>
              ) : (
                <Button
                  className="btn-primary"
                  onClick={LOGIN_ACCOUNT}
                >
                  Sign In
                </Button>
              )}  */}
              {/* <div className="divider">or continue with</div> */}
              <Button
                className="btn-microsoft"
                onClick={handleMicrosoftLogin}
              >
                <img src={msicon} alt="" /> Continue with Microsoft
              </Button>

              <div className="login-footer">
                <div>
                  Copyright <CopyrightOutlined />{" "}
                  {new Date().getFullYear()} Shalina Healthcare.
                </div>
              </div>

            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Login;